import { useEffect, useState } from "react";
import Image from "next/image";
import { useTranslation } from "@/app/i18n/client";
import HexagonInput from "@/common/customElements/HexagonInput";
import { CategoryDiv, InlineDiv } from "@/common/divs";
import { RegularText } from "@/common/texts";

import { CategoryRef, CategoryType } from "@/types/components";
import {
  NEUTRO_OVERLINE_COLOR,
  NEUTRO_PARAGRAPHS_COLOR,
  PRIMARY_BUTTON_COLOR,
} from "@/utils/constants";
import { renderCategoryIcon } from "@/utils/functions";
interface CategoryContainerProps {
  category: CategoryType;
  fromCheckbox?: boolean;
  categories: CategoryRef;
  parseTerm: (term: string) => void;
  deleteAll?: boolean;
}

const CategoryContainer: React.FC<CategoryContainerProps> = ({
  category,
  categories,
  parseTerm,
  fromCheckbox,
  deleteAll,
}) => {
  useEffect(() => {
    if (deleteAll) {
      setImSelected(false);
    }
  }, [deleteAll]);
  const [imSelected, setImSelected] = useState<boolean>(category.selected);
  const handleSelectCategory = () => {
    setImSelected(!imSelected);
    const foundCategory = categories.current.find(
      (cat: CategoryContainerProps["category"]) => cat.id === category.id,
    );
    if (foundCategory) {
      foundCategory.selected = !foundCategory.selected;
    }
    parseTerm(`cat:${category.id}`);
  };

  const { t } = useTranslation();

  return fromCheckbox ?
      <InlineDiv key={category.id} style={{ width: "245px" }}>
        <HexagonInput
          onClick={() => {
            handleSelectCategory();
          }}
          checked={category.selected}
        />
        <RegularText
          fontSize="14px"
          style={{
            marginLeft: "5px",
            color: NEUTRO_PARAGRAPHS_COLOR,
          }}
        >
          {t(category.i18_name)}
        </RegularText>
      </InlineDiv>
    : <CategoryDiv
        style={{
          background:
            category.selected ? PRIMARY_BUTTON_COLOR : NEUTRO_OVERLINE_COLOR,
        }}
        onClick={() => {
          handleSelectCategory();
        }}
      >
        <InlineDiv
          style={{
            justifyContent: "center",
            marginBottom: category.id === 4 ? "4px" : undefined,
          }}
        >
          <Image
            style={{ marginBottom: "3px", width: "24px", height: "24px" }}
            src={renderCategoryIcon(category.id)}
            alt={t(category.i18_name)}
            width={24}
            height={24}
          ></Image>
        </InlineDiv>
        {t(category.i18_name)}
      </CategoryDiv>;
};

export default CategoryContainer;
